import React from 'react';
import { Badge } from './ui/badge';

const PlatformsSection = () => {
  const platforms = [
    { name: 'Microsoft 365', icon: 'M', color: 'from-red-500 to-orange-500' },
    { name: 'Apple', icon: '🍎', color: 'from-gray-700 to-gray-900' },
    { name: 'Windows', icon: 'W', color: 'from-blue-500 to-blue-700' },
    { name: 'Cisco', icon: 'C', color: 'from-blue-600 to-cyan-600' },
    { name: 'Ubiquiti', icon: 'U', color: 'from-cyan-500 to-blue-500' },
    { name: 'Dell', icon: 'D', color: 'from-blue-500 to-blue-700' },
    { name: 'Synology', icon: 'S', color: 'from-orange-500 to-red-500' },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-3">Platforms We Support</h3>
          <p className="text-gray-600">
            We work with Microsoft 365, Apple, Windows, and modern network stacks.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4">
          {platforms.map((platform, index) => (
            <div
              key={index}
              className="flex items-center space-x-3 bg-white px-6 py-4 rounded-xl border border-gray-200 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`w-10 h-10 bg-gradient-to-br ${platform.color} rounded-lg flex items-center justify-center`}>
                <span className="text-white font-bold text-lg">{platform.icon}</span>
              </div>
              <span className="font-semibold text-gray-900">{platform.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformsSection;